import React, { Component } from 'react';
import './Card.css';  // Import the CSS for styling
import Path from '../../../../images/Path.png'

  class Card extends Component {
    render() {
      const { heading, subHeading, onClick, isActive, route, headingFontSize, subHeadingFontSize, cardSizeClass, imageSize, imagemaginLeft } = this.props;  // Destructuring props

      return (
        <div
          className={`card1 ${isActive ? 'active' : ''}`} // Add 'active' class if the card is active
          onClick={onClick}
          style={{ width: cardSizeClass }}  // Card width adjusts based on zoom
        >
          <div className="card-content1">
            <div className="card-heading">
              <h3 style={{ fontSize: headingFontSize }}>{heading}</h3>
              <span role="img" aria-label="icon" style={{marginLeft:imagemaginLeft }}>
                <img src={Path} alt="Toggle Icon" style={{ width: imageSize, height: imageSize }} />
              </span>
            </div>
            <div className="card-subheading">
              <p style={{ fontSize: subHeadingFontSize }}>{subHeading}</p> {/* Adjust subheading font size */}
            </div>
          </div>
        </div>
      );
    }
  }

export default Card;
